import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'firstKey'
})
export class FirstKeyPipe implements PipeTransform{
    transform(obj: any) {
        if(obj == null)
            return null;

        const keys = Object.keys(obj);

        if (keys && keys.length > 0)
            return keys[0];

        return null;
    }
}



// WEBPACK FOOTER //
// ./app/common/pipes/firstKeyPipe.ts